"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  MapServices: () => MapServices
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native = require("react-native");
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_unavailable = require("./unavailable");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneMapServices");
  return hybrid;
}
function search(query, center) {
  var radiusMeters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
  return native().search(query, center, radiusMeters).catch(import_nativeError.rethrowNativeError);
}
function autocomplete(query, center) {
  var radiusMeters = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 5e3;
  return native().autocomplete(query, center, radiusMeters).catch(import_nativeError.rethrowNativeError);
}
function resolveSuggestion(id) {
  return native().resolveSuggestion(id).catch(import_nativeError.rethrowNativeError);
}
function directions(origin, destination) {
  var transport = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "driving";
  return native().directions(origin, destination, transport).catch(import_nativeError.rethrowNativeError);
}
var nativeMapServices = Object.freeze({
  search,
  autocomplete,
  resolveSuggestion,
  directions
});
var androidMapServices = Object.freeze({
  search: nativeMapServices.search,
  autocomplete: import_unavailable.MapServices.autocomplete,
  resolveSuggestion: import_unavailable.MapServices.resolveSuggestion,
  directions: import_unavailable.MapServices.directions
});
var MapServices = import_react_native.Platform.OS === "android" ? androidMapServices : nativeMapServices;
//# sourceMappingURL=index.native.js.map
